import React, { Component } from 'react';
import DescriptiveText from './components/descriptiveText.js';
import CustomerHero from './components/customerHero';
import WebscreenSingle from './components/webscreenSingle';
import WebscreenDouble from './components/webscreenDouble';
import WebscreenMobile from './components/webscreenMobile';
import FullWidthImage from './components/fullWidthImage';
import CustomerQuote from './components/customerQuote';
import Footer from "./components/footer";

export default class Hyperlite extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			animations: []
  		};
  }
  componentDidMount() {
  }
  render() {
    return (
      <div>
        <CustomerHero company="Hoven Vision"
          title="A California-based eyewear company that blends fashion and function"
          video=""
          backgroundImage="images/hoven-top-hero.jpg"
          overlayColor="#7e68e7"
        />
        <div className="white-background large-margin-top">
          <DescriptiveText
            title="Company Overview"
            text="Hoven Vision produces high-quality sunglasses that are made to perform well and look great. They are committed to providing customers with sunglasses that enhance their lifestyle through exceptional quality and value."
          />
          <WebscreenSingle
            image="images/hoven-home.png"
          />
          <DescriptiveText
            title="Lifestyle Storytelling through Functional Design"
            text="Hoven approached Alpine Design with the goal of creating an engaging and intuitive e-commerce website that appealed to their wide range of customers. "
          />
          <WebscreenDouble
            image1="images/hoven-props-detail.png"
            image2="images/hoven-risky-detail.png"
          />

          <DescriptiveText
            title="Assets worth 1000 words"
            text="Alpine Design utilized Hoven's strong product assets and lifestyle imagery in order to showcase the quality and care put into each detail of Hoven's product line. "
          />
          <div className="max-width-container">
            <WebscreenSingle
              image="images/hoven-collections.png"
            />
          </div>
          <DescriptiveText
            title="Lookin' good while doing what you love"
            text="Hoven creates sunglasses that are catered to the interests and passions of their customers so it was crucial for the website to develop that connection through powerful imagery and effective design."
          />
          <div className="max-width-container">
            <FullWidthImage
              image="images/hoven-hero.jpg"
            />

          </div>
          <DescriptiveText
            title="There Goes My Hero"
            text="The hero images at the top of a webpage are some of the most crucial for capturing the attention of a user. By editing assets in a way that was consistent with Hoven's core design we were able to provide a cohesive branding experience across the site."
          />
        </div>
        {/*
          <CustomerQuote
          thumb="images/hyperlite-quote-thumb.jpg"
          name="Greg Nelson, VP of Marketing, Hyperlite Wakeboards"
          overlayColor="#009ba5"
          quote="Our websites are the most important parts of our marketing strategy- they invite consumers into our world so they can better know our brands. It's open all day everyday and it's critical to successful brand building. Alpine Design was (and is) as passionate about our brands as I am.  Our previous website was stale, tough to update and manage, and didn't tell our story. Alpine Design has changed all that!"
          backgroundImage="images/hyperlite-quote-background.jpg"
            />
        */}
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/hoven.js